import { Injectable } from '@angular/core'
import { BaseLoader } from '@adex/shared/models/loaders/base-loader'
import { HttpClient } from '@angular/common/http'
import { environment } from '../../../../environments'


@Injectable({
  providedIn: 'root'
})
export class ImageLoaderService extends BaseLoader {

  constructor(http: HttpClient) {
    super(http, value => `/assets/image/${ value }.svg?v=${ environment.version }`, [
      'adex_logo',
      'adex_logo_mini',
      'js_tag',
      'redirect_page'
    ], { responseType: 'text' as 'json' })
  }
}
